import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { ADD_AREA_ENTRY_STRATEGY } from './actionTypes';
import { addAreaEntryStrategySuccessful, addAreaEntryStrategyFailed } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

function* addAreaEntryStrategy({ payload: { token, strategyId, rcsArea, sortOrder, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.addAreaEntryStrategy, {
      token,
      strategyId,
      rcsArea,
      sortOrder,
    });
    yield put(addAreaEntryStrategySuccessful(response.message));
    history.go();
  } catch (error) {
    yield put(addAreaEntryStrategyFailed(error.message || error));
  }
}

export function* watchAddAreaEntryStrategy() {
  yield takeEvery(ADD_AREA_ENTRY_STRATEGY, addAreaEntryStrategy);
}

function* addAreaEntryStrategySaga() {
  yield all([fork(watchAddAreaEntryStrategy)]);
}

export default addAreaEntryStrategySaga;
